import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BrandHeader from "../components/BrandHeader";
import { useAuth } from "../lib/auth";

// Short-lived redirector: `/q/:instrumentId` (e.g. Instagram share) sends the
// user straight to /questionnaires with ?instrument=<id> so the picker can
// auto-enter that instrument's section. Unauthenticated hits bounce through
// /login?next=/q/:id so the deep link survives sign-in.
export default function InstrumentDeepLink() {
  const { instrumentId } = useParams();
  const { user, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (loading) return;
    const next = `/questionnaires?instrument=${encodeURIComponent(instrumentId)}`;
    if (!user) {
      nav(`/login?next=${encodeURIComponent(next)}`, { replace: true });
    } else {
      nav(next, { replace: true });
    }
  }, [user, loading, nav, instrumentId]);
  return (
    <div className="min-h-screen bg-background">
      <BrandHeader />
      <div className="mano-container-narrow py-20 text-muted-foreground"
           data-testid="deeplink-loading">
        Loading your questionnaire…
      </div>
    </div>
  );
}
